import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { Controls, FOCUS_TRANSITION, GameStats, Spinner, VideoPlayerEventNames, } from "core.components";
import { Subscription } from "rxjs";
import { DependencyToken } from "../Container";
import { container } from "../DefaultContainer";
export class Video extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._currentTime = 0;
        this._duration = 0;
        this._playing = false;
        this._live = false;
        this._previewEnded = false;
        this._statsOpen = false;
        this._subscriptions = new Subscription();
        this.Controls = this.getByRef("Controls");
        this.Shade = this.getByRef("Shade");
        this.ChannelBadge = this.getByRef("ChannelBadge");
        this.Logo = this.getByRef("Logo");
        this.Spinner = this.getByRef("Spinner");
        this.Stats = this.getByRef("Stats");
        this.VideoPlayer = this.getByRef("VideoPlayer");
    }
    static _template() {
        return {
            w: 1920,
            h: 1080,
            VideoPlayer: {
                type: container.get({ token: DependencyToken.VideoPlayer }),
            },
            Shade: {
                y: 547,
                w: 1920,
                h: 533,
                rect: true,
                colorTop: 0x00161616,
                colorBottom: 0xff161616,
            },
            Logo: {
                x: 1634,
                y: 73,
                w: 171,
                h: 60,
                texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/ligue-1-plus.svg"), 342, 120),
            },
            ChannelBadge: {
                x: 1722,
                y: 87,
                w: 83,
                h: 46,
                visible: false,
                rect: true,
                color: 0x33ffffff,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 4 },
                Label: {
                    text: {
                        text: "24/7",
                        fontFace: "Insatiable Display",
                        fontStyle: "700",
                        fontSize: 40,
                        h: 46,
                        lineHeight: 46,
                        offsetY: 38,
                        w: 83,
                        textAlign: "center",
                        textColor: 0xffffffff,
                    },
                },
            },
            Controls: {
                x: 115,
                y: 735,
                type: Controls,
                signals: {
                    togglePlayback: "$togglePlayPause",
                    seek: "$skip",
                    showStats: "$showStats",
                },
            },
            Stats: { type: GameStats, signals: { close: "$hideStats" } },
            Spinner: { type: Spinner, x: 960, y: 540, mount: 0.5, visible: false },
        };
    }
    set params({ href, title, category, mode = "vod", preview, programmeTime, nextTitle, nextTime, }) {
        if (!href) {
            Router.back();
            return;
        }
        const live = mode !== "vod";
        const linear = mode === "linear";
        this._currentTime = 0;
        this._duration = 0;
        this._pendingSeek = undefined;
        this._playing = false;
        this._live = live;
        this._preview = preview;
        this._previewEnded = false;
        this._statsOpen = false;
        this.Stats.close(false);
        this.Controls.reset();
        const controlsY = live ? 839 : 735;
        this.Controls.patch({
            y: linear ? 649 : controlsY,
            live,
            linear,
            title: title || "Ligue 1+",
            category: category || "Video",
        });
        if (linear)
            this.Controls.programme = {
                title: title || "Ligue 1+",
                time: programmeTime !== null && programmeTime !== void 0 ? programmeTime : "",
                next: nextTitle
                    ? { title: nextTitle, time: nextTime !== null && nextTime !== void 0 ? nextTime : "" }
                    : undefined,
            };
        this.Logo.patch({ x: linear ? 1543 : 1634, y: linear ? 80 : 73 });
        this.ChannelBadge.visible = linear;
        this.VideoPlayer.href = href;
        this.Spinner.visible = true;
        this.VideoPlayer.startPlayback();
    }
    _active() {
        // Keep the app background behind the white spinner until the first frame
        // can play; subsequent buffering leaves the video visible underneath.
        this.fireAncestors("$setVideoVisible", false);
        this._subscriptions.unsubscribe();
        this._subscriptions = new Subscription();
        this._subscriptions.add(this.VideoPlayer.buffering$.subscribe((buffering) => {
            this.Spinner.visible = buffering;
        }));
        this._subscriptions.add(this.VideoPlayer.duration$.subscribe((duration) => {
            this._duration = Number.isFinite(duration) ? Math.max(0, duration) : 0;
            this.Controls.duration = this._duration;
        }));
        this._subscriptions.add(this.VideoPlayer.currentTime$.subscribe((time) => {
            if (!Number.isFinite(time))
                return;
            if (this._finishPreview(time))
                return;
            // Keep the optimistic scrub position while old time events are in flight.
            if (this._pendingSeek !== undefined) {
                if (Math.abs(time - this._pendingSeek) > 1000)
                    return;
                this._pendingSeek = undefined;
            }
            this._currentTime = Math.max(0, time);
            this.Controls.currentTime = this._currentTime;
        }));
        this._subscriptions.add(this.VideoPlayer.playing$.subscribe((playing) => {
            this._playing = playing;
            this.Controls.paused = !playing;
            if (playing) {
                this.Spinner.visible = false;
                this.fireAncestors("$setVideoVisible", true);
            }
        }));
        this._subscriptions.add(this.VideoPlayer.events$.subscribe((event) => {
            if (event === VideoPlayerEventNames.Ended ||
                event === VideoPlayerEventNames.Error)
                this.Spinner.visible = false;
            if (event === VideoPlayerEventNames.Ended)
                Router.back();
            if (event === VideoPlayerEventNames.Seeked ||
                event === VideoPlayerEventNames.Error)
                this._pendingSeek = undefined;
        }));
        this._showControls();
    }
    _finishPreview(time) {
        if (this._previewEnded)
            return true;
        if (this._preview !== "ligue-3" || time < 30000)
            return false;
        this._previewEnded = true;
        clearTimeout(this._controlsTimeout);
        this._controlsTimeout = undefined;
        // Ignore late player events while the paywall replaces this page.
        this._subscriptions.unsubscribe();
        this.Spinner.visible = false;
        this.VideoPlayer.pause();
        // The player's normal _inactive lifecycle releases playback on navigation.
        // store=false keeps Video out of history, so Back returns straight to Home.
        Router.navigate("subscribe/ligue-3", false);
        return true;
    }
    _setControlsAlpha(alpha, duration = FOCUS_TRANSITION.duration) {
        [this.Controls, this.Shade, this.Logo, this.ChannelBadge].forEach((element) => {
            element.setSmooth("alpha", alpha, Object.assign(Object.assign({}, FOCUS_TRANSITION), { duration }));
        });
    }
    _showControls(duration = FOCUS_TRANSITION.duration) {
        if (this._statsOpen || this._previewEnded)
            return;
        clearTimeout(this._controlsTimeout);
        this._setControlsAlpha(1, duration);
        this._controlsTimeout = setTimeout(() => {
            this._controlsTimeout = undefined;
            this._setControlsAlpha(0);
        }, 3000);
    }
    _captureKey() {
        if (this._previewEnded)
            return true;
        // Observe input before the focused control consumes it, then let it act.
        this._showControls();
        return false;
    }
    _captureKeyRelease() {
        if (this._previewEnded)
            return true;
        this._showControls();
        return false;
    }
    _getFocused() {
        return this._statsOpen ? this.Stats : this.Controls;
    }
    _inactive() {
        clearTimeout(this._controlsTimeout);
        this._controlsTimeout = undefined;
        this._subscriptions.unsubscribe();
        this._pendingSeek = undefined;
        this.Spinner.visible = false;
        this._statsOpen = false;
        this.Stats.close(false);
        this.fireAncestors("$setVideoVisible", false);
    }
    $showStats() {
        if (!this._live || this._statsOpen)
            return;
        this._statsOpen = true;
        clearTimeout(this._controlsTimeout);
        this._controlsTimeout = undefined;
        this._setControlsAlpha(0, 0.25);
        this.Stats.open();
        this._refocus();
    }
    $hideStats() {
        if (!this._statsOpen)
            return;
        this._statsOpen = false;
        this.Stats.close();
        this._showControls(0.25);
        this._refocus();
    }
    $skip(delta) {
        var _a;
        if (this._live ||
            this._previewEnded ||
            !Number.isFinite(delta) ||
            this._duration <= 0)
            return;
        // Keep a small end buffer, matching the player adapter, including short VODs.
        const end = Math.max(0, this._duration - 2000);
        const time = Math.max(0, Math.min(end, ((_a = this._pendingSeek) !== null && _a !== void 0 ? _a : this._currentTime) + delta));
        if (this._finishPreview(time))
            return;
        this._pendingSeek = time;
        this._currentTime = time;
        this.Controls.currentTime = time;
        this.VideoPlayer.seekTo(time);
    }
    $togglePlayPause() {
        if (this._playing)
            this.VideoPlayer.pause();
        else
            this.VideoPlayer.play();
    }
    _handlePlayPause() {
        this.$togglePlayPause();
        return true;
    }
    _handlePlay() {
        this.VideoPlayer.play();
        return true;
    }
    _handlePause() {
        this.VideoPlayer.pause();
        return true;
    }
    _handleRewind() {
        this.$skip(-10000);
        return true;
    }
    _handleFastForward() {
        this.$skip(10000);
        return true;
    }
    _handleSkipBackward() {
        this.$skip(-30000);
        return true;
    }
    _handleSkipForward() {
        this.$skip(30000);
        return true;
    }
    _handleStop() {
        Router.back();
        return true;
    }
}
export default Video;
//# sourceMappingURL=Video.js.map